import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "stat-card__top" }
const _hoisted_2 = { class: "stat-card__icon" }
const _hoisted_3 = { class: "stat-card__label" }
const _hoisted_4 = { class: "stat-card__value" }
const _hoisted_5 = {
  key: 0,
  class: "stat-card__detail"
}
const _hoisted_6 = ["aria-valuenow"]


export default /*@__PURE__*/_defineComponent({
  __name: 'StatCard',
  props: {
    label: {},
    value: {},
    detail: {},
    trend: {},
    tone: {},
    icon: {},
    progress: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["stat-card", `stat-card--${__props.tone || 'forest'}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass(["uil", __props.icon || 'uil-chart']),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      (__props.trend)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["stat-card__trend", { 'stat-card__trend--down': __props.trend.startsWith('-') }])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["uil", __props.trend.startsWith('-') ? 'uil-arrow-down' : 'uil-arrow-up'])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(__props.trend), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.label), 1),
    _createElementVNode("strong", _hoisted_4, _toDisplayString(__props.value), 1),
    (__props.detail)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.detail), 1))
      : _createCommentVNode("", true),
    (__props.progress !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "stat-card__progress",
          role: "progressbar",
          "aria-valuenow": __props.progress,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: `${Math.min(100, Math.max(0, __props.progress))}%` })
          }, null, 4)
        ], 8, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}
}

})